/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Matrix routing service implementation using using the TomTom's
 * [Routing API - Matrix Routing](https://developer.tomtom.com/routing-api/routing-api-documentation/matrix-routing).
 *
 * The Routing API - Matrix Routing service allows calculation of a matrix of route summaries for a set of routes
 * which are defined with origin and destination locations.
 *
 * For every given origin this service calculates
 * the cost of routing from that origin to every given destination. The set of origins and the set of destinations
 * can be thought of as the column and row headers of a table and each cell in the table contains the costs of routing
 * from the origin to the destination for that cell.
 *
 * The following costs are computed for each route:
 * - Travel times
 * - Distances
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "MatrixRouting/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "MatrixRouting/go:method"}}{{/crossLink}} method to handle the response.
 *
 * @class MatrixRouting
 * @module Services
 * @uses Chain
 * @uses KeyMixin
 *
 * @constructor
 * @param {Object} [options] Options to be passed to the routing call,
 *     or Array of such options objects to perform batch request.
 * @param {String} [options.key=global API key] An API Key issued
 *     from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {Array} [options.origins] A set of origin locations represented by coordinates (lat, lon).
 *     At least one origin is required.
 * @param {Array} options.destinations A set of destination locations represented by coordinates (lat, lon).
 *     At least one destination is required.
 * @param {String} [options.routeType] The type of route requested.
 * @param {Boolean} [options.traffic] Determines if traffic data should be used to calculate the route
 * @param {String} [options.travelMode] The travel mode for the requested route. The possible values are documented
 *     {{#crossLink "MatrixRouting/travelMode:method"}}here{{/crossLink}}.
 * @param {String} [options.avoid] Specifies something that the route calculation should try to avoid when
 *     determining the route. The possible values are documented
 *     {{#crossLink "MatrixRouting/avoid:method"}}here{{/crossLink}}.
 * @param {String} [options.departAt] The date and time of departure from the origin point
 * @param {String} [options.arriveAt] The date and time of arrival at the destination point
 *     response
 * @param {String} [options.hilliness] Degree of hilliness for thrilling route. The possible values are documented
 *     {{#crossLink "MatrixRouting/hilliness:method"}}here{{/crossLink}}.
 * @param {Number} [options.vehicleAxleWeight] The vehicle axle weight in kg.
 * @param {Boolean} [options.vehicleCommercial] True if vehicle is used for commercial purposes.
 * @param {String} [computeTravelTimeFor] Setting to _all_ provides additional information regards travel times.
 * @param {String} [options.vehicleEngineType] The vehicle engine type. One of "combustion" or "electric"
 * @param {Number} [options.vehicleHeight] The vehicle height in m.
 * @param {Number} [options.vehicleLength] The vehicle length in meters.
 * @param {Array|String} [options.vehicleLoadType] The array of truck cargo classification.
 *     The possible values are documented {{#crossLink "MatrixRouting/vehicleLoadType:method"}}here{{/crossLink}}.
 * @param {Number} [options.vehicleMaxSpeed] The maximal allowed vehicle speed in km/h.
 * @param {Number} [options.vehicleWeight] The vehicle weight in kg.
 * @param {Number} [options.vehicleWidth] The vehicle width in m.
 * @param {String} [options.windingness] Level of turns for thrilling route.
 *     The possible values are documented {{#crossLink "MatrixRouting/windingness:method"}}here{{/crossLink}}.
 * @param {String} [options.protocol] Protocol's type, one of "http" or "https".
 *
 * @example
 * ```js
 * var origins = [
 *   { point: { latitude: 51.63685, longitude: 19.4171 } },
 *   { point: { latitude: 51.63685, longitude: 19 } }
 * ];
 * var destinations = [
 *   { point: { latitude: 52.23498, longitude: 21.00849 } },
 *   { point: { latitude: 52.63685, longitude: 18 } }
 * ];
 * function callbackFn(routeGeoJson) {
 *   console.log(routeGeoJson);
 * }
 * var request = tomtom.matrixRouting({
 *   origins: origins,
 *   destinations: destinations,
 *   traffic: true
 * });
 * request.go()
 *   .then(callbackFn);
 * ```
 */
/* jshint nomen:false */
define([
    'rest/routing',
    'model/routing/matrixRouting',
    '../chain',
    './matrixParameters'
],
function(restRouting, matrixRoutingModel, chain, matrixParameters) {
    'use strict';

    var fields = matrixParameters();
    var routing = restRouting();

    function handleChain(data, callback) {
        routing.matrix(data, function(response) {
            callback.call(this, matrixRoutingModel(response));
        });
    }

    return function(options) {
        var opt = options || {};
        opt.__serviceType = 'routing';

        return chain(fields, handleChain, opt);
    };
});



// WEBPACK FOOTER //
// ./services/routing/matrixRouting.js